import React, { useEffect, useState } from "react";
import AddEditForm from "./ItemAddEditForm";
import { axios } from "../../../../../Global";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ListDataRateCategoryItems from "./ListDataRateItem";
import { printValidationError } from "../../../../../utils/functions";
import { validateWith2Array } from "../../../../../utils/EditChangeValidate";

export default function RateCategoryItems() {
  const location = useLocation();
  const categoryItemId = location.pathname.split("/").at(3);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [clientList, setClientList] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [oneTimeCost, setOneTimeCost] = useState("");
  const [monthlyCost, setMonthlyCost] = useState("");
  const [eightHourCost, setEightHourCost] = useState("");
  const [tenHourCost, setTenHourCost] = useState("");
  const [updated, setUpdated] = useState(false);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [prevState, setPrevState] = useState({});

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (location.pathname.split("/").at(-1) === "#edit") {
      setAddOrEdit((p) => ({
        ...p,
        open: true,
        method: "edit",
      }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location.pathname]);

  useEffect(() => {
    setToggleLoading(true);
    axios
      .get(`/dashboard/rate-category`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const allData = res.data.data;
        // console.log("alldata", allData);
        const basic = allData[0]?.rate_category_item?.filter(
          (item) => item.name === "BASIC"
        )[0]?.cost;
        const food = allData[0]?.rate_category_item?.filter(
          (item) => item.name === "FOOD"
        )[0]?.cost;
        const particularData = allData.find((a) => a.id == categoryItemId);
        console.log("particularData", particularData);
        if (particularData?.name == "SoundLine Fee") {
          let total = Number(food) + Number(basic);
          let gosi = 0.02 * total;
          let rate_category_item = particularData?.rate_category_item;
          rate_category_item.splice(2, 0, {
            name: "GOSI",
            cost: "2% of EMP (BASIC + HRA)",
          });
        }
        if (particularData?.name == "Government Fee") {
          let rate_category_item = particularData?.rate_category_item;

          rate_category_item.splice(
            rate_category_item?.findIndex(
              (data) => data?.name == "END OF SERVICE"
            ),
            1,
            {
              name: "END OF SERVICE",
              cost: "(Basic Salary / 30) * 15 / 12",
            }
          );
          rate_category_item.splice(
            rate_category_item?.findIndex(
              (data) => data?.name == "VACATION SALARY"
            ),
            1,
            {
              name: "VACATION SALARY",
              cost: "(Basic Salary / 30) * 21 / 12",
            }
          );
        }
        setClientList(particularData.rate_category_item);
        setToggleLoading(false);
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        setToggleLoading(false);
      });
  }, [updated]);

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = {
        name,
        short_description: description,
        onetime_cost: oneTimeCost,
        monthly_cost: monthlyCost,
        eight_hour_cost: eightHourCost,
        ten_hour_cost: tenHourCost,
        rate_category_id: categoryItemId,
      };
      if (addOrEdit.method === "edit") {
        // To Validate Form Modified
        const prevArray = [
          prevState.name,
          prevState.short_description,
          prevState.onetime_cost,
          prevState.monthly_cost,
          prevState.eight_hour_cost,
          prevState.ten_hour_cost,
        ];
        const currArray = [
          name,
          description,
          oneTimeCost,
          monthlyCost,
          eightHourCost,
          tenHourCost,
        ];
        const changed = validateWith2Array(prevArray, currArray);
        if (!changed) {
          setSubmitFormLoading(false);
          return dispatch(setAppError({ msg: "No changes made" }));
        }

        response = await axios.put(
          `/dashboard/rate-category-item/${addOrEdit.editId}`,
          body,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      const data = response.data.data;
      if (data) {
        navigate(`/dashboard/rate-category/${categoryItemId}`);
        setUpdated((prev) => !prev);
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      setSubmitFormLoading(false);
      printValidationError(err, "rateCategory");
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const cancelForm = () => {
    navigate(`/dashboard/rate-category/${categoryItemId}`);
    setAddOrEdit((p) => ({ ...p, open: false }));
  };

  const editData = async (id, data) => {
    navigate(`/dashboard/rate-category/${categoryItemId}/edit/${id}`);
    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        await new Promise((resolve) => setTimeout(resolve, 200));
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          loadedValues: data,
          editId: id,
        }));
        setPrevState((p) => ({
          name: data.name,
          short_description: data.short_description,
          onetime_cost: data.onetime_cost,
          monthly_cost: data.monthly_cost,
          eight_hour_cost: data.eight_hour_cost,
          ten_hour_cost: data.ten_hour_cost,
        }));
        setName(data.name);
        setDescription(data.short_description);
        setOneTimeCost(data.onetime_cost);
        setMonthlyCost(data.monthly_cost);
        setEightHourCost(data.eight_hour_cost);
        setTenHourCost(data.ten_hour_cost);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };

  return (
    <>
      {addOrEdit.open ? (
        <AddEditForm
          component="rateCategory"
          form={[
            {
              type: "text",
              text: "Name",
              name: "name",
              value: name,
              update: setName,
              disabled: true,
            },
            {
              type: "text",
              text: "Description",
              name: "description",
              value: description,
              update: setDescription,
              columnName: "short_description",
            },
            {
              type: "number",
              text: "One-Time Cost",
              name: "oneTimeCost",
              value: oneTimeCost,
              update: setOneTimeCost,
              columnName: "onetime_cost",
            },
            {
              type: "number",
              text: "Monthly Cost",
              name: "monthlyCost",
              value: monthlyCost,
              update: setMonthlyCost,
              columnName: "monthly_cost",
            },
            {
              type: "number",
              text: "Eight Hour Cost",
              name: "Eight Hour Cost",
              value: eightHourCost,
              update: setEightHourCost,
              columnName: "eight_hour_cost",
            },
            {
              type: "number",
              text: "Ten Hour Cost",
              name: "Ten Hour Cost",
              value: tenHourCost,
              update: setTenHourCost,
              columnName: "ten_hour_cost",
            },
          ]}
          prevState={prevState}
          submitForm={submitForm}
          cancelForm={cancelForm}
          submitFormLoading={submitFormLoading}
          loadedValues={
            addOrEdit.method === "edit" && addOrEdit.loadedValues ? true : false
          }
          monthlyCost={monthlyCost}
          setTenHourCost={setTenHourCost}
          setEightHourCost={setEightHourCost}
        />
      ) : (
        <ListDataRateCategoryItems
          list={clientList}
          editData={editData}
          // deleteData={setShowPromptElement}
          setUpdated={setUpdated}
          listLoading={toggleLoading}
          loading={loading}
          column={7}
          titles={[
            "S.NO.",
            "ITEMS",
            "COST",
            "ACTUALS",
            "12 MONTHS",
            "24 MONTHS",
            "Action",
          ]}
        />
      )}
    </>
  );
}
